import bundleService from '../../../../services/bundles/bundle-service';

type FetchMaterialWithSuggestionsProps = { materialIds: number[]; limit: number };
type MaterialWithSuggestions = { id: number; bundleIds: number[] } | null;

// e.g., Cart: 3 materials (ids: 111, 222, 333)
// Request: `?ids=111,222,333&limit=3`
// Response: `{111: [456,786], 222: [321,432,543], 333: []}`
// (key = cart item id from request, value = related bundle ids filtered by user purchases)
const fetchMaterialWithSuggestions = async (
    props: FetchMaterialWithSuggestionsProps
): Promise<MaterialWithSuggestions> => {
    const { materialIds, limit } = props;

    const { suggestions } = await bundleService.getBundlesSuggestions({ ids: materialIds, limit });

    // response is automatically ordered in numeric asc order by js
    // we need to use `materialIds` to reconstruct the proper order
    const selectedMaterialId = materialIds.find((key): boolean => (suggestions[key] ?? []).length > 0);

    return selectedMaterialId ? { id: selectedMaterialId, bundleIds: suggestions[selectedMaterialId] } : null;
};

export default fetchMaterialWithSuggestions;
